import React, { useState } from 'react'

/**
 * LocationCell component - displays a URL with truncation and tooltip
 * @param {string} url - The full URL to display
 * @param {number} maxLength - Maximum length before truncation (default: 50)
 */
const LocationCell = ({ url, maxLength = 50 }) => {
  const [showTooltip, setShowTooltip] = useState(false)

  // Handle empty/null URLs
  if (!url) {
    return <span style={{ color: '#999', fontStyle: 'italic' }}>No URL</span>
  }

  // Truncate URL if too long
  const displayUrl = url.length > maxLength 
    ? url.substring(0, maxLength) + '...' 
    : url

  const containerStyle = {
    position: 'relative',
    display: 'inline-block',
    maxWidth: '100%'
  }

  const linkStyle = {
    color: '#0073bb',
    textDecoration: 'none',
    cursor: 'pointer',
    wordBreak: 'break-all'
  }

  const tooltipStyle = {
    position: 'absolute',
    bottom: '100%',
    left: '0',
    backgroundColor: '#333',
    color: '#fff',
    padding: '8px 12px',
    borderRadius: '4px',
    fontSize: '12px',
    whiteSpace: 'nowrap',
    zIndex: 9999,
    marginBottom: '5px',
    maxWidth: '400px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
    pointerEvents: 'none'
  }

  return (
    <div 
      style={containerStyle}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <a 
        href={url} 
        target="_blank" 
        rel="noopener noreferrer"
        style={linkStyle}
        title={url}
      >
        {displayUrl}
      </a>
      
      {showTooltip && (
        <div style={tooltipStyle}>
          {url}
        </div>
      )}
    </div>
  )
}

export default LocationCell
